var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z",
    fill: "#05BC86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6899 5.30416C16.1034 5.7097 16.1034 6.36723 15.6899 6.77273L8.63102 13.6958C8.21752 14.1014 7.54721 14.1014 7.13366 13.6958L4.31012 10.9266C3.89663 10.521 3.89663 9.86362 4.31012 9.45806C4.72361 9.05251 5.39403 9.05251 5.80753 9.45806L7.88236 11.4929L11.0374 8.39855L14.1925 5.30416C14.6061 4.89861 15.2764 4.89861 15.6899 5.30416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a417ea43266f17a0036383194d1dbd1b.svg";
export { ForwardRef as ReactComponent };